module.exports = __webpack_public_path__ + "static/media/ios.9d80bc06.png";